'use strict';

/**
 * Detect if click event or touchstart (device)
 *
 * @type {string}
 */

export default class Events {
    static clickEventType() {
        if ('ontouchstart' in document.documentElement === true) {
            return 'touchstart';
        } else {
            return 'click';
        }
    }
}

export const CUSTOM_EVENTS = Object.freeze({
    WHOS_WATCHING_CLICK: 'whosWatchingClick'
});
